import React, { FunctionComponent } from "react";
import { SectionHeading, ContentSection, Paragraph } from '@vwfs-bronson/bronson-react';
import { Output } from '../Text';

type ExpiredSessionProps = {};

const ExpiredSessionPage: FunctionComponent<ExpiredSessionProps> = () => {

  return (
    <ContentSection pageWrap>
      <SectionHeading level="3">
        {Output.resolve(
          "expiredSession.title"
        )}
      </SectionHeading>
      <Paragraph>
        {Output.resolve(
          "expiredSession.text"
        )}
      </Paragraph>
    </ContentSection>
  );
}

export { ExpiredSessionPage };
